import { ILink } from 'detailsv2/LandingV2/TableOfContents/types';

export const useNavigationLinks = (link: ILink, activePageId: number) => {
  const isEmptyItem = !link.name;
  const linkText = isEmptyItem ? 'Section Name' : link.name;
  const isActive = link.id === activePageId;

  return { linkText, isActive };
};
